import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Group, alpha, useMantineTheme } from "@mantine/core";
import { useCallback } from "react";
import { useIntl } from "react-intl";
export const ChatSuggestions = ({ inputRef }) => {
    const intl = useIntl();
    const { colors: { gray } } = useMantineTheme();
    const suggestions = [
        // intl.formatMessage({ id: "chat.suggestion.retro", defaultMessage: "Make it look like a vintage road atlas" }),
        intl.formatMessage({ id: "chat.suggestion.starbucks", defaultMessage: "Style map like starbucks" }),
        intl.formatMessage({ id: "chat.suggestion.walk", defaultMessage: "15-minute walk from the Eiffel Tower" }),
        intl.formatMessage({ id: "chat.suggestion.cafes", defaultMessage: "Pin all cafes in Kreuzberg" }),
    ];
    const handleSuggestion = useCallback((text) => {
        if (inputRef.current) {
            const proto = window.HTMLTextAreaElement.prototype;
            /**
             * We need to trigger change event manually for onChange to work
             * @see https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-change-or-input-event-in-react-js
             */
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const trigger = Object.getOwnPropertyDescriptor(proto, "value")?.set;
            trigger?.call(inputRef.current, text);
            const event = new Event("change", { bubbles: true });
            inputRef.current.dispatchEvent(event);
        }
    }, [inputRef]);
    return (_jsx(Group, { gap: "md", justify: "center", wrap: "wrap", children: suggestions.map(text => (_jsx(Button, { variant: "light", color: "gray", size: "xs", onClick: () => { handleSuggestion(text); }, style: { backgroundColor: alpha(gray[6], 0.1) }, children: text }, text))) }));
};
